import { useEffect, useState } from "react";

export function useStickyNav(threshold = 1) {
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrolled =
        document.body.scrollTop > threshold ||
        document.documentElement.scrollTop > threshold;
      setSticky(scrolled);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return sticky;
}
